module.exports = __webpack_public_path__ + "static/media/H5_WON_March_2.f9d568a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/H5_WON_March_2.jpg
// module id = 438
// module chunks = 0